export const floatingToolbarLight = "#FFFFFFA9";
export const floatingToolbarOutlined = "rgba(255,255,255,0.27)";
export const floatingToolbarDark = "#202020";
export const floatingToolbarDarkHover = "#444";
export const floatingToolbarDarkActive = "#666";
export const floatingToolbarDisabled = "grey.700";
